/**
 * @Author: Zewei
 * @Date:   2018-01-22T13:07:45+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T10:42:29+08:00
 */

import React from 'react';
import { connect } from 'react-redux';
import { login } from '../../actions/user-actions';
import { Form, Icon, Input, Button, Alert, Spin } from 'antd';
import UserLayoutWrapper from '../../layouts/UserLayoutWrapper.js';
import './style.less';

const FormItem = Form.Item;

class LoginForm extends React.Component {

    state={
        loginError:""
    }

   handleSubmit = (e) => {
     e.preventDefault();
     this.props.form.validateFields((err, values) => {
       if (!err) {
          // 测试用 Code 暂时写死
         let userInfo = {...values, Code: '123456'};
         this.props.login(userInfo,res=>{
            // console.log(res);
            if(res.data.Errors[0]){
                this.setState({loginError:res.data.Errors[0]})
            }
            else{
                this.setState({loginError:res.data.Message})
            }  
         });
       }
     });
   }

   render() {
     const { getFieldDecorator } = this.props.form;
     const { loginStatus } = this.props.user;

     return (
         <div className="main">
             {
                 loginStatus === false ?
                    <Alert style={{marginBottom: 10}} message={this.state.loginError?this.state.loginError:"用户名或密码错误，请联系人事"} type="error" />
                    :
                    ''
             }
             <Form onSubmit={this.handleSubmit} className="login-form">
                <div className="loginLable">USERNAME</div>
                 <FormItem>
                     {getFieldDecorator('Username', {
                         rules: [{ required: true, message: '请输入账号!' }],
                     })(
                         <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="账号" />
                     )}
                 </FormItem>
                 <div className="loginLable">PASSWORD</div>
                 <FormItem>
                     {getFieldDecorator('Password', {
                         rules: [{ required: true, message: '请输入密码!' }],
                     })(
                         <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
                     )}
                 </FormItem>
                 <div></div>
                 <div>
                    <div className="remember"></div>
                    <FormItem className="loginButton">
                        <Button type="primary" htmlType="submit" className="login-form-button" disabled={this.props.user.submitting}>
                            {this.props.user.submitting ? <span><Spin style={{marginRight: 10}} />登录中...</span> : <span>Login</span> }
                        </Button>
                    </FormItem>
                 </div>
                 
             </Form>
         </div>
     );
   }
 }

const mapStateToProps = (state) => {
    return {
      user: state.user,
      routing: state.routing
    }
};
const actionCreators = { login };

let WrappedLoginForm = connect(mapStateToProps, actionCreators)(LoginForm);

WrappedLoginForm = Form.create()(WrappedLoginForm);

WrappedLoginForm = UserLayoutWrapper(WrappedLoginForm);


export default WrappedLoginForm;



// WEBPACK FOOTER //
// ./src/routes/Login/index.js